
/*
  In a sane world this would be `subpage_display` but we keep it this way for 
  historical reasons. This is what is was before "project codesbane" when
  we used the word "sections" to describe the feature which is now "subpages"
*/
export const SUBPAGE_DISPLAY_ACTION_NAME = 'section_display'; 

